export default "dist/images/block-blockquote-huge.ce498b6.png";